export default __webpack_public_path__ + "static/media/logo.1c144aaa.jpeg";